const cardImage = document.querySelectorAll('.grid__item12');

// function removeNumbersFromEnd(str) {
//   const regex = /(\d+)$/;
//   const match = str.match(regex);
//   if (match) {
//     return Number(match[1]);
//   } else {
//     return null;
//   }
// }

// cardImage.forEach(img => {
//     img.addEventListener("mouseover", event => {
//         let productId = event.target.getAttribute("id");
//       console.log("product-id==", productId);
//         const removedNumber = removeNumbersFromEnd(productId);
//         document.getElementById(`quick-view-button-${removedNumber}`).style.display = 'block';
//         const btn = document.getElementById(`quick-view-button-${removedNumber}`);
//         btn.addEventListener("mouseover", event=>{
//           btn.style.display = 'block';
//         })
//     });

//     img.addEventListener("mouseout", event => {
//         let productId = event.target.getAttribute("id");
//             console.log("product-id==", productId);
//         const removedNumber = removeNumbersFromEnd(productId);
//         document.getElementById(`quick-view-button-${removedNumber}`).style.display = 'none';
//     });
// });

// Track selected colors globally
let selectedFilterColors = new Set();

// Simple color filter detection for your specific structure
document.addEventListener('change', function(event) {
  const target = event.target;
  
  // Check if it's a color filter checkbox
  if (target.type === 'checkbox' && target.name === 'filter.v.option.color') {
    const colorValue = target.value.toLowerCase();
    
    if (target.checked) {
      // Add color to selected set
      selectedFilterColors.add(colorValue);
    } else {
      // Remove color from selected set
      selectedFilterColors.delete(colorValue);
    }
    
    // Apply smart color selection after filter change with better AJAX handling
    setTimeout(() => {
      applySmartColorSelection();
    }, 1500);
    
    // Also try again after a longer delay in case AJAX is slow
    setTimeout(() => {
      applySmartColorSelection();
    }, 3000);
    
    // Final retry for very slow AJAX
    setTimeout(() => {
      applySmartColorSelection();
    }, 4500);
    
    // Watch for DOM changes to detect when new products are loaded
    watchForProductChanges();
  }
});

// Intelligent function to select the best color variant for each product
function applySmartColorSelection() {
  // Get all visible product items
  const productItems = document.querySelectorAll('.grid__item:not([style*="display: none"])');
  
  productItems.forEach((productItem, index) => {
    const productId = productItem.getAttribute('data-product-id');
    const availableColors = productItem.getAttribute('data-available-colors');
    
    if (!productId || !availableColors) {
      return;
    }
    
    // Find which of the selected filter colors this product has
    const productColorsArray = availableColors.split(',').map(color => color.trim().toLowerCase());
    
    const matchingColors = [];
    
    selectedFilterColors.forEach(filterColor => {
      if (productColorsArray.includes(filterColor)) {
        matchingColors.push(filterColor);
      }
    });
    
    // Apply black border to all matching color swatches
    if (matchingColors.length > 0) {
      // Use setTimeout to ensure DOM is ready
      setTimeout(() => {
        matchingColors.forEach(color => {
          const colorUpper = color.toUpperCase();
          const colorNoSpace = colorUpper.replace(/\s+/g, '');
          
          // Try multiple selector patterns to find variant images
          const selectors = [
            `.variant-image[data-color*="${colorNoSpace}-${productId}"] img`,
            `.variant-image[data-color="${colorNoSpace}-${productId}"] img`,
            `.variant-image[title="${colorUpper}"] img`
          ];
          
          selectors.forEach(selector => {
            const variantSwatches = productItem.querySelectorAll(selector);
            variantSwatches.forEach(img => {
              img.style.border = '2px solid #000';
              img.style.borderRadius = '30px';
            });
          });
        });
      }, 100);
      
      // Choose the best color to display based on priority
      const colorToSelect = chooseBestColor(matchingColors, productColorsArray);
      
      // Remove spaces from color name to match data-color attribute format
      const colorNoSpace = colorToSelect.toUpperCase().replace(/\s+/g, '');
      
      // Find and click the color swatch - updated selector to match the HTML structure
      const colorSwatch = productItem.querySelector(`.variant-image[data-color*="${colorNoSpace}-${productId}"] .color-option`);
      
      if (colorSwatch) {
        colorSwatch.click();
      } else {
        // Try alternative selector patterns with no space
        const altSelector1 = productItem.querySelector(`.variant-image[data-color="${colorNoSpace}-${productId}"] .color-option`);
        const altSelector2 = productItem.querySelector(`.color-option[data-color="${colorNoSpace}-${productId}"]`);
        const altSelector3 = productItem.querySelector(`.variant-image[title="${colorToSelect.toUpperCase()}"] .color-option`);
        
        if (altSelector1) altSelector1.click();
        else if (altSelector2) altSelector2.click();
        else if (altSelector3) altSelector3.click();
      }
    }
  });
}

// Function to choose the best color when multiple filter colors match a product
function chooseBestColor(matchingColors, productColors) {
  // Priority order: most recently selected color first
  const sortedFilterColors = Array.from(selectedFilterColors).reverse();
  
  // Return the first matching color from our priority list
  for (const filterColor of sortedFilterColors) {
    if (matchingColors.includes(filterColor)) {
      return filterColor;
    }
  }
  
  // Fallback: return the first matching color
  return matchingColors[0];
}

// Function to reapply selections when needed
function reapplyAllColorSelections() {
  applySmartColorSelection();
}

// Watch for DOM changes to detect when new products are loaded via AJAX
function watchForProductChanges() {
  const productGrid = document.querySelector('#product-grid, .collection-products, .grid--product-grid, [data-id*="collection"]');
  
  if (productGrid) {
    // Create a MutationObserver to watch for changes
    const observer = new MutationObserver((mutations) => {
      let productsChanged = false;
      
      mutations.forEach((mutation) => {
        // Check if products were added or removed
        if (mutation.type === 'childList' && 
            (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
          // Check if the changes involve product cards
          const relevantChanges = Array.from(mutation.addedNodes).some(node => 
            node.nodeType === 1 && (
              node.classList?.contains('grid__item') || 
              node.querySelector?.('.grid__item') ||
              node.classList?.contains('card-wrapper')
            )
          );
          
          if (relevantChanges) {
            productsChanged = true;
          }
        }
      });
      
      if (productsChanged) {
        setTimeout(() => {
          applySmartColorSelection();
        }, 800);
        
        // Retry after additional delay
        setTimeout(() => {
          applySmartColorSelection();
        }, 2000);
      }
    });
    
    // Start observing
    observer.observe(productGrid, {
      childList: true,
      subtree: true
    });
  }
}

// Initialize selected colors from already checked checkboxes on page load
document.addEventListener('DOMContentLoaded', function() {
  // Check for already selected color filters
  document.querySelectorAll('input[type="checkbox"][name="filter.v.option.color"]:checked').forEach(checkbox => {
    const colorValue = checkbox.value.toLowerCase();
    selectedFilterColors.add(colorValue);
  });
  
  // Apply smart selection after a delay
  if (selectedFilterColors.size > 0) {
    setTimeout(() => {
      applySmartColorSelection();
    }, 1500);
    
    // Retry for page load
    setTimeout(() => {
      applySmartColorSelection();
    }, 3000);
  }
  
  // Set up the product change watcher
  watchForProductChanges();
});

// Listen for Shopify AJAX events (common in themes)
document.addEventListener('shopify:section:load', function() {
  setTimeout(() => {
    applySmartColorSelection();
  }, 1000);
  
  setTimeout(() => {
    applySmartColorSelection();
  }, 2000);
});

// Listen for fetch completion (modern AJAX)
const originalFetch = window.fetch;
window.fetch = function(...args) {
  return originalFetch.apply(this, args).then(response => {
    // Check if this was a collection/filter request
    if (args[0] && typeof args[0] === 'string' && 
        (args[0].includes('/collections/') || args[0].includes('filter'))) {
      setTimeout(() => {
        applySmartColorSelection();
      }, 1500);
      
      setTimeout(() => {
        applySmartColorSelection();
      }, 3000);
    }
    return response;
  });
};